import script from "./AdminIssueReportFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminIssueReportFormView.vue?vue&type=script&setup=true&lang=js"

import "./AdminIssueReportFormView.vue?vue&type=style&index=0&id=f61b6ba0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f61b6ba0"]])

export default __exports__